import React from 'react';
import iconLoading from '../../../images/spinner.svg';

const Spinner = () => (
  <span role="progressbar">
    <div>
      <img src={iconLoading} className="spinner" alt={'icon loading'}/>
    </div>
  </span>
);

export default Spinner;
